import { render } from "./MypagePage.vue?vue&type=template&id=24706846&scoped=true&ts=true"
import script from "./MypagePage.vue?vue&type=script&lang=ts"
export * from "./MypagePage.vue?vue&type=script&lang=ts"

import "./MypagePage.vue?vue&type=style&index=0&id=24706846&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24706846"]])

export default __exports__